import { IFilter } from "@saleor/components/Filter";
import { FilterOpts, MinMax } from "@saleor/types";
import { createDateField } from "@saleor/utils/filters/fields";
import { defineMessages, IntlShape } from "react-intl";

export enum CustomerInfoFilterKeys {
  joined = "joined"
}

export interface CustomerInfoListFilterOpts {
  joined: FilterOpts<MinMax>;
}

const messages = defineMessages({
  joinDate: {
    defaultMessage: "Date Joined",
    description: "customer"
  }
});

export function createFilterStructure(
  intl: IntlShape,
  opts: CustomerInfoListFilterOpts
): IFilter<CustomerInfoFilterKeys> {
  return [
    {
      ...createDateField(
        CustomerInfoFilterKeys.joined,
        intl.formatMessage(messages.joinDate),
        opts.joined.value
      ),
      active: opts.joined.active
    }
  ];
}
